import { useEffect, useState } from 'react'

type CartQuantityStepperProps = {
  value: number
  onChange: (quantity: number) => void
  min?: number
  step?: number
  /** Минус на минимальном количестве убирает позицию, а не упирается в неактивную кнопку. */
  onRemove?: () => void
}

const parseQuantity = (text: string): number | null => {
  const normalized = text.trim().replace(',', '.')
  if (normalized === '') {
    return null
  }
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

export const CartQuantityStepper = ({
  value,
  onChange,
  min = 1,
  step = 1,
  onRemove,
}: CartQuantityStepperProps) => {
  const [draft, setDraft] = useState(String(value))

  useEffect(() => {
    setDraft(String(value))
  }, [value])

  const handleDecrement = () => {
    if (value - step < min) {
      onRemove?.()
      return
    }
    onChange(value - step)
  }

  const handleIncrement = () => {
    onChange(value + step)
  }

  const handleInputChange = (text: string) => {
    setDraft(text)
    const parsed = parseQuantity(text)
    if (parsed != null && parsed >= min) {
      onChange(parsed)
    }
  }

  const handleBlur = () => {
    const parsed = parseQuantity(draft)
    if (parsed == null || parsed < min) {
      setDraft(String(value))
      return
    }
    onChange(parsed)
    setDraft(String(parsed))
  }

  return (
    <div className="market-qty-stepper">
      <button
        type="button"
        className="market-qty-stepper__btn market-qty-stepper__btn--decrement"
        aria-label={value - step < min && onRemove ? 'Убрать позицию' : 'Уменьшить количество'}
        disabled={value <= min && !onRemove}
        onClick={handleDecrement}
      >
        −
      </button>
      <input
        className="echat-field__input market-qty-stepper__input"
        inputMode="decimal"
        aria-label="Количество"
        value={draft}
        onChange={(event) => handleInputChange(event.target.value)}
        onBlur={handleBlur}
      />
      <button
        type="button"
        className="market-qty-stepper__btn market-qty-stepper__btn--increment"
        aria-label="Увеличить количество"
        onClick={handleIncrement}
      >
        +
      </button>
    </div>
  )
}
